import { Injectable } from '@angular/core';
import { AbstractNursecallService, Maker, NursecallInput } from './abstract-nursecall.service';
import { AlertController } from 'ionic-angular';
import { NurseCallService } from '../nurse-call.service';

@Injectable()
export class CocohelpaService extends AbstractNursecallService {

  constructor(
    protected alertCtrl: AlertController,
    protected nurseCallService: NurseCallService,
  ) {
    super(alertCtrl, nurseCallService);
  }

  placeholderText() {
    return "ジーコム社から受け取ったCSVファイルの中身を貼り付けてください";
  }

  columns() {
    return [
      { key: "roomCode", text: "お部屋コード", checkValidate: true, isShowConfirm: true },
      { key: "roomName", text: "お部屋名", checkValidate: false, isShowConfirm: true },
    ];
  }

  parse({ inputText }: { inputText: string }) {
    const rows: NursecallInput[] = [];
    const _rows = inputText.split('\n');
    const headerRows = 4; // 読み込まないヘッダー行

    let currentRow = 1;
    for (const row of _rows) {
      if (currentRow < headerRows) {
        currentRow++;
        continue;
      }
      const columns = row.split('\t');
      rows.push({
        ctlId: '1', // 固定値
        equipId: '1', // 固定値
        callNoCd: '', // 固定値
        roomCode: columns[0], // 病棟/フロアコード
        roomName: columns[2], // 部屋名
        bedNo: '1', // 固定値
        memo: '', // 固定値
      });
    }
    return rows;
  }

  async validate({ maker, rows }: { maker: Maker, rows: NursecallInput[] }) {
    // チェック対象のカラムを取得
    const targetColumns = this.columns().filter((column) => column.checkValidate);
    if (!this.validateRows(rows, targetColumns)) {
      return false;
    }
    if (!this.validateDuplicated(rows, targetColumns)) {
      return false;
    }
    if (!await this.validateRegistered(maker, rows, targetColumns)) {
      return false;
    }
    return true;
  }

}



// WEBPACK FOOTER //
// ./src/providers/nursecall/cocohelpa.service.ts